const { showError } = require('../libs/helper')

module.exports = {
  getBmd: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/get-list-bmd`,
      params,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
}
